export const MeticulousProjectId = 'G3GAFdYkCVibKVfKYtNfrZvqNWcMa9HuDGr6nsaw'
export const MeticulousSnippetSrc =
  'https://snippet.meticulous.ai/v1/meticulous.js'
